// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"688":"803a53fd","974":"41a44ce3"}[chunkId] + ".chunk.css";
};